import { CardContentType, CommonCardCategory } from '../types/commonTypes';

export const IMAGES = {
  CHIP_LOGO:
    'https:images.ctfassets.net/r5kx3olu0gzs/2kTcBw4fSSbmFQdbHD9yDL/a4978fab730b89b4ee3e19af99fc906c/rb_chip.png',
  RB_MASTER_CARD_LOGO:
    'https://images.ctfassets.net/r5kx3olu0gzs/1KuuhMyLDUzZAwxOXqxaQT/b3011f126d37acf5912e78d1743dc0bf/master_card_logo.png',
  RB_LOGO:
    'https://images.ctfassets.net/r5kx3olu0gzs/2qgkkrhuqzfThkkg3jMDpb/36403b725ee2b49a8870a1b11e60e30f/rb_logo_white.png',
  NAVIGATE_RIGHT_ICON:
    'https://images.ctfassets.net/r5kx3olu0gzs/1UTcc9LSG2ox62Ey15DmM0/c65680e0be4c59f472543bde3c0e9c94/navigate_next.png',
  INFO_ICON:
    'https://images.ctfassets.net/r5kx3olu0gzs/2moqB1AsIqrWBpmReMukH7/a458ba88661e92e351a16fe0beda2f63/info_icon.png',
  DECLINED:
    'https://images.ctfassets.net/r5kx3olu0gzs/7aT5jRLkKMvFLRoZh0E4Bk/aeebb30d57d48b9fc587ccd11c3d0d2f/declined_status.png',
  PENDING:
    'https://images.ctfassets.net/r5kx3olu0gzs/2AIy9oK4Jd3iI2dm2UaGbf/36e2a64620d15b386fc7be2bf5c77534/pending_status.png',
  HOME: 'https://images.ctfassets.net/r5kx3olu0gzs/6fZWmy8LLIht2U3B7fqPdc/dec7c23f4f1af187ba0d0ede813ce58b/icn-home.png',
  OFFERS:
    'https://images.ctfassets.net/r5kx3olu0gzs/u0TWTFYGMv0lmUCleg2oI/848c3fe3cc239c11cd73754f551f8f41/icn-offer.png',
  MANAGE_CARD:
    'https://images.ctfassets.net/r5kx3olu0gzs/2YJih8N7YOGex4UOVN5bZi/8293ac7c0cf38143f886e3b5ebe39b86/icn-master-card.png',
  RB_CARD_LOGO:
    'https://images.ctfassets.net/r5kx3olu0gzs/7ug9Sh1xXsWinltHPO4exa/032664ce48442143bd0782fbd0406d9e/rogers_card_logo.png',
  REWARDS:
    'https://images.ctfassets.net/r5kx3olu0gzs/4b93iW5WirGa60yOMUSfN6/0349908434b7841c3c046e75de6786eb/icn-rewards.png',
  MORE: 'https://images.ctfassets.net/r5kx3olu0gzs/1wmOpUaJ0HtrJ64vBFBK2k/3e75d00214718108429be07fbefc8b32/icn-more.png',
  RB_VERTICAL_CARD:
    'https://images.ctfassets.net/r5kx3olu0gzs/4Stwqn2hfVJkimrDgW6juk/68defc97eac700069132408c6ea7d0c1/rb_vertical_card_bg.png',
  RB_HORIZONTAL_CARD:
    'https://images.ctfassets.net/r5kx3olu0gzs/27xONF6w6ITAkRjed2H4AI/59aed8afe07cbf6f586902307968ab32/rb_horizontal_card_bg.png',
  RB_MASTER_CARD_LOGO_GREY:
    'https://images.ctfassets.net/r5kx3olu0gzs/6RbqXfsGayz1E7cFxhvi7t/397d6d64905c56e0530f5143322f48ff/rb_master_card_logo_grey.png',
};

export const imageMap = {
  Home: IMAGES.HOME,
  Rewards: IMAGES.REWARDS,
  'Manage Card': IMAGES.MANAGE_CARD,
  Offers: IMAGES.OFFERS,
  More: IMAGES.MORE,
};

// This will be removed in future, when the contentful is integrated
export const CONTENTFULL: CardContentType = {
  ACD_TITLE: (val: string) => `Credit limit : $${val}`,
  ACD_CHIP_TITLE_ONE: 'Current balance',
  ACD_CHIP_TITLE_TWO: 'Available credit',

  STMT_TITLE: (val: string) => `Payment due on ${val}`,
  STMT_CHIP_TITLE_ONE: 'Statement balance',
  STMT_CHIP_TITLE_TWO: 'Minimum payment',

  RECENT_TRANSACTIONS: 'Recent Transactions',

  CTA_ACC_DETAILS: 'View account details',
  CTA_STATEMENTS: 'View statements',
  CTA_ALL_TRANSACTIONS: 'View all transactions',
};

export const CTA_MAPS: Record<CommonCardCategory, keyof CardContentType> = {
  [CommonCardCategory.ACCOUNT]: 'CTA_ACC_DETAILS',
  [CommonCardCategory.STATEMENT]: 'CTA_STATEMENTS',
  [CommonCardCategory.TRANSACTION]: 'CTA_ALL_TRANSACTIONS',
};

export const getContentByCategory = (
  category: CommonCardCategory,
  value = ''
): string => {
  const propertyKey = CTA_MAPS[category];
  const content = CONTENTFULL[propertyKey];

  if (typeof content === 'function') {
    return content(value);
  }

  return content;
};

export const AccessibilityLabels = {
  CARD: 'This is the Master Card',
  CHIP_LOGO: 'Master Card Chip Image',
  MASKED_CARD_NUMBER: 'Masked Card Number',
  MASTER_CARD_LOGO: 'Master Card Logo',
  REWARD_BALANCE_LABEL: 'Reward Balance',
  INFO_ICON: 'Info Icon',
  RB_CARD_LOGO: 'Roger Logo',
};

export const HORIZONATAL_CARD = ['20180625134509'];

export const blockAccountText =
  "Looks like you don't have permission to do this right now. Please contact customer service for further assistance.";
